import { IProduct_ProductFixedPriceProject_Fragment } from '@99designs/apps/spa/pages/create/briefs/Brief.generated';
import { IProductFragment } from './../briefs/Brief.generated';

export function isFixedPriceFragment(
    obj: IProductFragment
): obj is IProduct_ProductFixedPriceProject_Fragment {
    if (obj.__typename && obj.__typename === 'ProductFixedPriceProject') {
        return true;
    }
    return false;
}
